import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'tsyringe';
import { placeholders } from '@gn-audio/core/common/helpers';
import { BasketEventBus } from '../../services/basket-event-bus.service';
import { emulateClickWhenEnterOrSpacePressed } from '../../utilities';
import { BasketUIItemComponent } from '../basket-ui-item/basket-ui-item.component';
import './basket-ui.component.scss';
import template from './basket-ui.component.html';
var BasketUIComponent = /** @class */ (function () {
    function BasketUIComponent(eventBus, translations) {
        var _this = this;
        this.eventBus = eventBus;
        this.translations = translations;
        this.components = [];
        this.showUI = function () {
            _this.overlay.classList.add("visible" /* CssClass.Visible */);
            _this.container.classList.add("visible" /* CssClass.Visible */);
        };
        this.hideUI = function () {
            _this.container.classList.remove("visible" /* CssClass.Visible */);
            _this.overlay.classList.remove("visible" /* CssClass.Visible */);
        };
        this.updateUI = function (state) {
            _this.components.forEach(function (c) { return c.destroy(); });
            _this.components.length = 0;
            (state.product_items || []).forEach(function (item) {
                if (item.c_isService) {
                    return;
                }
                var component = new BasketUIItemComponent();
                _this.components.push(component);
                component.render({
                    container: _this.content,
                    eventBus: _this.eventBus,
                    data: item,
                    translations: _this.translations,
                });
            });
        };
    }
    BasketUIComponent.prototype.register = function (state) {
        this.createUI();
        this.attachEvents();
        this.updateUI(state);
        this.toggleUIWhenFocusChanges();
    };
    BasketUIComponent.prototype.createUI = function () {
        var _this = this;
        this.container = document.createElement('div');
        this.container.classList.add('basket-ui');
        this.container.setAttribute('role', 'dialog');
        document.body.appendChild(this.container);
        this.container.innerHTML = placeholders(template, {}, this.translations);
        this.container.addEventListener('keydown', function (event) {
            if (event.key !== "Escape" /* KeyboardCode.Esc */) {
                return;
            }
            _this.hideUI();
        });
        this.closeIcon = this.container.querySelector(".basket-ui__header-icon" /* BasketUIElementSelector.BasketHeaderIcon */);
        this.closeIcon.addEventListener('click', this.hideUI);
        this.closeIcon.addEventListener('keydown', function (event) {
            emulateClickWhenEnterOrSpacePressed(event, _this.closeIcon);
        });
        this.overlay = document.createElement('div');
        this.overlay.classList.add('basket-ui-overlay');
        document.body.appendChild(this.overlay);
        this.overlay.addEventListener('click', this.hideUI);
        this.content = this.container.querySelector(".basket-ui__content" /* BasketUIElementSelector.BasketContent */);
    };
    BasketUIComponent.prototype.attachEvents = function () {
        this.eventBus.subscribe("show-basket-ui" /* BasketEvent.ShowBasketUI */, this.showUI);
        this.eventBus.subscribe("hide-basket-ui" /* BasketEvent.HideBasketUI */, this.hideUI);
        this.eventBus.subscribe("basket-updated" /* BasketEvent.BasketUpdated */, this.updateUI);
    };
    BasketUIComponent.prototype.toggleUIWhenFocusChanges = function () {
        var _this = this;
        this.container.querySelectorAll('a, button, input, [tabindex]').forEach(function (item) {
            item.addEventListener('focus', _this.showUI);
        });
        document.addEventListener('focusin', function (event) {
            var isFocusInsideBasketContainer = _this.container.contains(event.target);
            if (isFocusInsideBasketContainer) {
                return;
            }
            var engravingPopup = document.querySelector('.basket-engraving-popup');
            if (engravingPopup === null || engravingPopup === void 0 ? void 0 : engravingPopup.contains(event.target)) {
                return;
            }
            _this.hideUI();
        });
    };
    BasketUIComponent = __decorate([
        injectable(),
        __param(1, inject("basketTranslations" /* DiToken.Translations */)),
        __metadata("design:paramtypes", [BasketEventBus, Object])
    ], BasketUIComponent);
    return BasketUIComponent;
}());
export { BasketUIComponent };
